var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGarden = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.7 20.4v13.3M24.9 14.8h.4c.5-.2-.1-.6.3-1 1.3-1.3 1.4-2.8.5-3.6-.8-.8-2.2-.8-3.5.3v-.1c0-1.8-1-2.9-2.2-2.9s-2.1 1-2.2 2.6c-1.2-1.2-2.7-1.3-3.6-.4-.8.9-.7 2.4.6 3.6.1.1.2.1.2.2-1.8 0-2.9 1-2.9 2.3 0 1.2 1.1 2.2 3 2.2h.4c-.1.2-.2.3-.2.5-.7 1.7-.2 3.1 1 3.6 1.1.5 2.4-.2 3.1-1.8.7 1.5 2 2.1 3.1 1.6.9-.4 1.4-1.4 1.2-2.7.2 0 .4.1.6.1 1.8.1 3-.8 3.1-2-.1-1.3-1.1-2.4-2.9-2.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9 13.6A1.5 1.5 0 1 1 19.9 16.6 1.5 1.5 0 0 1 19.9 13.6Z"
}))));
export default SvgGarden;